module.exports = __webpack_public_path__ + "img/41.bfc8ac4e.png";